import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors";

const SalaryManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "white",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    padding: "18px 20px",
    display: "flex",
    alignItems: "center",
    gap: "18px",
    cursor: "pointer",
    transition: "0.2s",
    minHeight: "120px",
    height: "100%",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subheading = {
    fontSize: "12px",
    opacity: 0.7,
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  return (
    <div style={{ background: "#ffffff", minHeight: "100vh" }} className="flex justify-center items-start p-6">
      <div className="w-full max-w-7xl">

        

        {/* Grid: 3 columns desktop, 1 mobile */}
        <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`} style={{ alignItems: "stretch" }}>

          {/* Ledger */}
          <Link to="/ledgerStaff" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-book" style={{ ...iconStyle, color: "#FF3B30" }}></i>
              <div>
                <h2 style={heading}>Ledger</h2>
                <p style={subheading}>Manage staff salary ledger and advances.</p>
              </div>
            </div>
          </Link>

          {/* Give Salary */}
          <Link to="/give-salary" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i className="fas fa-wallet" style={{ ...iconStyle, color: "#06B6D4" }}></i>
              <div>
                <h2 style={heading}>Give Salary</h2>
                <p style={subheading}>Distribute salary to staff.</p>
              </div>
            </div>
          </Link>


        </div>
      </div>
    </div>
  );
};

export default SalaryManagement;
